import { SiteService } from '@app/_services/site.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AuthenticationService } from '@services/authentication.service';
import { Component, Input, OnInit, Renderer2 } from '@angular/core';
import { ChatService } from '@app/_services/chat.service';
import { DirectionService } from '@app/_services/direction.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ChatModalComponent } from '../chat-modal/chat-modal.component';
import { Title } from '@angular/platform-browser';
import { DeviceDetectorService } from 'ngx-device-detector';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { BidiModule } from '@angular/cdk/bidi';
import { MatMenuModule } from '@angular/material/menu';
import { NgIf, NgClass } from '@angular/common';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'app-chat-window',
    templateUrl: './chat-window.component.html',
    styleUrls: ['./chat-window.component.scss'],
    standalone: true,
    imports: [NgIf, MatMenuModule, NgClass, BidiModule, MatIconModule, TranslateModule]
})
export class ChatWindowComponent implements OnInit {
    // @Input() label: String = 'Start chat';
    @Input() floatingButton: boolean = true;
    bsModalRef: BsModalRef = null;
    newMessages = 0;
    permissions = {
        canGetSupport: true,
        canGetConsultation: false,
        canGetVendor: false
    };
    companyData;
    productData;

    constructor(
        private modalService: BsModalService,
        private chatService: ChatService,
        private authService: AuthenticationService,
        private titleService: Title,
        private router: Router,
        private route: ActivatedRoute,
        private renderer: Renderer2,
        public direction: DirectionService,
        public deviceDetector: DeviceDetectorService,
        public siteService: SiteService
    ) {
        this.router.events.pipe(untilDestroyed(this)).subscribe((event) => {
            if ((event instanceof NavigationEnd)) {
                var rt = this.getChild(this.route.firstChild);
                rt.data.subscribe(data => {
                    this.companyData = null;
                    this.productData = null;

                    if (data.products) {
                        this.companyData = data.company?.company || data.products?.product?.companyData;
                        this.productData = data.products?.product ?? null;
                    }
                });
            }
        });

        this.modalService.onHide.pipe(untilDestroyed(this)).subscribe(() => {
            this.renderer.removeClass(document.body, 'chat-modal');
        });

        this.modalService.onShown.pipe(untilDestroyed(this)).subscribe(() => {
            this.renderer.addClass(document.getElementsByClassName('live-chat-popup')[0].parentElement, 'live-chat');

            if (this.deviceDetector.isMobile()) {
                this.renderer.addClass(document.getElementsByClassName('modal')[0], 'mobile');
            }
        });

        // this.modalService.onHidden.subscribe(() => {
        //     this.renderer.removeClass(document.getElementsByClassName('live-chat-popup')[0].parentElement, 'live-chat');
        // });

        this.authService.currentUser.pipe(untilDestroyed(this)).subscribe({
            next: (response) => {
                this.newMessages = response?.unreadCount ?? 0;
            }
        });

        this.chatService.wsChat$.pipe(untilDestroyed(this)).subscribe((res: any) => {
            if (res.type == 'new_chat_message' && !res.data?.message?.sentFromUser) {
                this.newMessages++;
            }
        });
    }

    ngOnInit(): void {
        this.authService.settings.pipe(untilDestroyed(this)).subscribe(settings => {
            if (settings?.chat) {
                this.permissions.canGetSupport = settings.chat.enableSupportChat;
                this.permissions.canGetConsultation = settings.chat.enableConsultChat;
                this.permissions.canGetVendor = settings.chat.enableVendorChat;
            }
        });
        // console.log(this.companyData);
    }

    getChild(activatedRoute: ActivatedRoute) {
        if (activatedRoute.firstChild) {
            return this.getChild(activatedRoute.firstChild);
        } else {
            return activatedRoute;
        }
    }

    openChat(chatType: 'vendor' | 'support' | 'consult'): any {
        this.newMessages = 0;

        if (!this.authService.currentUserValue) {
            return this.router.navigate(['/login'], { queryParams: { returnUrl: this.router.routerState.snapshot.url } });
        }

        if (chatType == 'vendor' && !this.permissions.canGetVendor) {
            return false;
        } else if (chatType == 'support' && !this.permissions.canGetSupport) {
            return false;
        } else if (chatType == 'consult' && !this.permissions.canGetConsultation) {
            return false;
        }

        // create chat
        var newChat: any = {
            "subject": {
                "type": this.productData ? "product" : "page",
                "title": this.productData?.name ?? {
                    "en": this.titleService.getTitle(),
                    "ar": this.titleService.getTitle(),
                },
                "url": window.location.href,
                "ObjectId": this.productData?._id,
            },
            "type": chatType,
            "message": ""
        };

        if (this.companyData?._id && chatType == 'vendor') {
            newChat.companyId = this.companyData._id
        }

        this.chatService.createChat(newChat).pipe(untilDestroyed(this)).subscribe((response: any) => {
            // console.log("CREATE CHAT::", response);

            this.bsModalRef = null;

            const initialState = {
                chatId: response.data?._id
            };

            this.bsModalRef = this.modalService.show(ChatModalComponent, {
                initialState,
                class: 'full-screen live-chat-popup',
                backdrop: false,
                ignoreBackdropClick: true
            });

            this.bsModalRef.content.closeBtnName = 'Close';

            this.renderer.addClass(document.body, 'chat-modal');
        });
    }
}
